import { initTelemetry } from './telemetry';
import React from 'react';
import ReactDOM from 'react-dom';
import { MemoryRouter } from 'react-router-dom';
import App from './App';
// import reportWebVitals from './reportWebVitals';

initTelemetry();

ReactDOM.render(
  <React.StrictMode>
    <MemoryRouter future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}>
      <App />
    </MemoryRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
